import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["row", "container", "addButton"];

  connect() {
    this.updateAllConditionalFields();
  }

  updateAllConditionalFields() {
    this.rowTargets.forEach((row) => this.updateConditionalFields(row));
  }

  updateConditionalFields(row) {
    const roleSelect = row.querySelector('select[name*="[role]"]');
    const teacherFields = row.querySelector(".teacher-fields");
    const supervisorFields = row.querySelector(".supervisor-fields");

    if (!roleSelect || !teacherFields || !supervisorFields) return;

    const toggleFields = () => {
      const role = roleSelect.value;
      teacherFields.classList.add("d-none");
      supervisorFields.classList.add("d-none");

      if (role === "teacher") {
        teacherFields.classList.remove("d-none");
      } else if (role === "supervisor") {
        supervisorFields.classList.remove("d-none");
      }
    };

    roleSelect.addEventListener("change", toggleFields);
    toggleFields(); // Trigger once on load
  }
}
